import React from "react";

/* Lightweight stylized platform monograms (no copyrighted marks).
 * Focused exclusively on gig delivery & rideshare platforms during the
 * pilot/MVP stage. Creator + freelancer platforms have been removed.
 */
const palette = {
  doordash:  { bg: "#1A0F0F", fg: "#FF3B30", label: "D", name: "DoorDash", emoji: "🚗" },
  uber:      { bg: "#0F0F0F", fg: "#FFFFFF", label: "U", name: "Uber",     emoji: "🚘" },
  lyft:      { bg: "#150A1F", fg: "#C77DFF", label: "L", name: "Lyft",     emoji: "🚖" },
  instacart: { bg: "#1F1808", fg: "#FFD60A", label: "I", name: "Instacart", emoji: "🛒" },
  spark:     { bg: "#0A1F12", fg: "#00FF88", label: "S", name: "Spark",    emoji: "⚡" },
  roadie:    { bg: "#1A1208", fg: "#FFB066", label: "R", name: "Roadie",   emoji: "📦" },
};

export const PlatformIcon = ({ id, size = 36, withName = false }) => {
  const p = palette[id] || palette.doordash;
  return (
    <div className="inline-flex items-center gap-2" data-testid={`platform-${id}`}>
      <div
        style={{ width: size, height: size, background: p.bg, color: p.fg }}
        className="rounded-xl grid place-items-center font-display font-extrabold border border-white/10 shadow-inner"
      >
        <span style={{ fontSize: size * 0.45 }}>{p.label}</span>
      </div>
      {withName && (
        <span className="text-white/70 text-sm font-semibold">{p.name}</span>
      )}
    </div>
  );
};

export const platformList = Object.entries(palette).map(([id, v]) => ({ id, ...v }));
